<svg class="progress-bar" viewBox="0 0 22 22">
  <circle class="progress-bar__overlay" cx="11" cy="11" r="10" />
  <path [attr.d]="arcData" [ngClass]="context" class="progress-bar__filler" />
</svg>
<svg-icon-sprite *ngIf="iconSrc" [src]="iconSrc"></svg-icon-sprite>
